/**
 * Converts camelCase string to Title Case with spaces
 *
 * @param key - camelCase field name (e.g., 'attackSurface')
 * @returns Title Case label (e.g., 'Attack Surface')
 *
 * @example
 * camelCaseToLabel('attackSurface') // 'Attack Surface'
 * camelCaseToLabel('dns') // 'Dns'
 * camelCaseToLabel('cloudId') // 'Cloud Id'
 */
export function camelCaseToLabel(key: string): string {
  if (!key) return '';

  return key
    .replace(/([A-Z])/g, ' $1') // Insert space before capitals
    .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
    .trim();
}
